module.exports = __webpack_public_path__ + "static/media/8.822382d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/8.svg
// module id = 131
// module chunks = 0